import HttpService from './httpService';

const base64ToBytes = (base64) => Uint8Array.from(atob(base64), char => char.charCodeAt(0));
const generatedFiles = {};


const generateHardwareBom = async (projectId, imosFile) => {
    const fd = new FormData();
    fd.append('file', imosFile);
    fd.append('customerName', 'hardware_bom');

    let imosFileLink;
    try {
        imosFileLink = (await HttpService.uploadFile(fd)).data;
    } catch (error) {
        throw new Error('Could not upload the IMOS material list');
    }

    let data;
    try {
        ({ data } = await HttpService.generateHardwareBom({ projectId, imosFileLink }));
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Hardware BOM generation failed');
    }

    const bomData = base64ToBytes(data.bomFileBase64);
    generatedFiles[data.bomFileLink] = bomData;

    return {
        bomUrl: data.bomFileLink,
        reportUrl: data.reportFileLink,
        bomData,
    };
};

const downloadFile = async (url) => {
    if (generatedFiles[url]) return generatedFiles[url].buffer;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Could not read the generated file');
    return response.arrayBuffer();
};

const HardwareBomService = { generateHardwareBom, downloadFile };

export default HardwareBomService;
